<template>
  <div class="text-center">
    <v-dialog v-model="show" max-width="450">
      <v-card>
        <v-card-title class="mb-5 text-h4 font-weight-medium"
          >Reservar línea</v-card-title
        >
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <vuetify-money
              v-model="form.amount"
              label="Monto a reservar"
              placeholder="Monto a reservar"
              :rules="[(v) => !!v || 'El campo es requerido']"
              v-bind:options="options"
              outlined
            />
            <v-text-field
              v-model="form.days"
              label="Días de reserva"
              type="number"
              :rules="[(v) => !!v || 'El campo es requerido']"
              outlined
            ></v-text-field>
            <v-text-field
              v-model="form.reference"
              label="Referencia (opcional)"
              placeholder="Ej: Proyecto Construcción ABC"
              outlined
              hint="Describe el propósito de esta línea reservada"
              persistent-hint
            ></v-text-field>
            <v-text-field
              v-model="form.user_id"
              label="Número de usuario"
              type="number"
              :rules="[(v) => !!v || 'El campo es requerido']"
              outlined
            ></v-text-field>
            <v-text-field
              v-model="form.token"
              label="Código de compra (Token)"
              type="number"
              :rules="[(v) => !!v || 'El campo es requerido']"
              outlined
            ></v-text-field>

            <div
              v-if="message"
              class="red--text text-center mb-4 font-weight-medium text-h6"
            >
              {{ message }}
            </div>

            <v-row>
              <v-col cols="6">
                <v-btn @click="close" block outlined> Cerrar </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  style="background: #1d1d1f; color: #fff"
                  @click="validate"
                  :disabled="loading"
                  block
                  outlined
                >
                  {{ loading ? "Cargando..." : "Crear" }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <!-- <v-col cols="6">
                <v-btn
                  @click="close"
                  block
                  outlined
                >
                  Cerrar
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  style="background: #1d1d1f ; color: #fff"
                  @click="validate"
                  :disabled="loading"
                  block
                  outlined
                >
                {{ loading ? "Cargando..."  : "Crear" }}
                </v-btn>
              </v-col> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ReservedCreditLineService from "../../services/reservedCreditLineService";
import options from "@/config/money";

export default {
  props: ["visible"],

  data() {
    return {
      isLoading: false,
      form: {
        amount: "",
        days: null,
        user_id: null,
        token: null,
        reference: null,
      },

      loading: false,
      message: null,
      valid: false,
    };
  },

  methods: {
    async validate() {
      const isValid = this.$refs.form.validate();

      if (!isValid) {
        return;
      }

      await this.handleSubmit();
    },

    async handleSubmit() {
      if (this.form.user_id == null) {
        this.message = "Debe cargar el ID de usuario";
        return;
      }

      this.loading = true;

      const response = await ReservedCreditLineService.create(this.form);
      const result = await response.json();
      const status = response.status;

      if (status == 200) {
        this.$emit("showMessage", { success: true, msg: result.msg });
        this.close();
      } else {
        this.message = result.msg;
      }

      this.loading = false;
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    reset() {
      this.form.amount = "";
      this.form.days = null;
      this.form.user_id = null;
      this.form.token = null;
      this.form.reference = null;
      this.message = null;
    },
  },

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.close();
        }
      },
    },
    options: () => {
      return options;
    },
  },
};
</script>
